import fromPairs from "ramda/es/fromPairs";
import o from "ramda/es/o";
import values from "ramda/es/values";
import mapIndexed from "ramda-extension/es/mapIndexed";
import { baseValidationPriority, baseValidationTypes } from '../constants';
const mapIndexedPairs = o(fromPairs, mapIndexed((val, index)=>[
        val,
        index + 3
    ]));
let validationTypes = values(baseValidationTypes);
let validationPriority = baseValidationPriority;
let pristineValidationTypes = [];
let notPresentValidationTypes = [];
export const registerCustomValidationTypes = (customTypes, customPristineValidationTypes = [], customNotPresentValidationTypes = [])=>{
    validationTypes = [
        ...validationTypes,
        ...customTypes
    ];
    pristineValidationTypes = customPristineValidationTypes;
    notPresentValidationTypes = customNotPresentValidationTypes;
    validationPriority = {
        ...baseValidationPriority,
        ...mapIndexedPairs(customTypes)
    };
};
export const getValidationTypes = ()=>validationTypes;
export const getPristineValidationTypes = ()=>pristineValidationTypes;
export const getNotPresentValidationTypes = ()=>notPresentValidationTypes;
export const getValidationPriority = ()=>validationPriority;
